import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/conversation24.webp';
import screenshot_target from '../../../images/letterfunnel/nickblom.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Nick Blom"
      firstname="Nick"
      companyname="Conversation24"
      competition="Charles en Trengo"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/nickblom.js